import React from 'react';

export const SourceBadges = {
  RareBoard: (
    <svg className={`icon relative z-10 h-[30px] w-[30px] md:h-[32px] md:w-[32px]`}>
      <use xlinkHref={`/icons.svg#source-rareboard`} />
    </svg>
  ),
};
